import React, { FunctionComponent } from 'react';
import styles from '../../../styles/CategoryText.module.scss';
import Link from 'next/link';
import { Routes } from '../../../constants/Routes';

type Props = {
    categorySlug?: string;
    fontSize?: string;
    color?: string;
    className?: string;
};

export const CategoryText: FunctionComponent<React.PropsWithChildren<Props>> = ({
    children,
    fontSize,
    color,
    categorySlug,
    className,
}) => {
    if (categorySlug) {
        return (
            <Link
                href={Routes.openCategory(categorySlug ? categorySlug : '#')}
                className={`${styles.main} ${className}`}
                style={{ fontSize, color }}>
                {children}
            </Link>
        );
    }

    return (
        <div className={`${styles.main} ${className}`} style={{ fontSize, color }}>
            {children}
        </div>
    );
};
